{
    "actions": {
        "page": {
            "add_contract_access": "New merchant account"
        },
        "row": {
            "activate": "Reactivate",
            "deactivate": "Desactivate",
            "update_label": "Update label "
        }
    },
    "filter": {
        "placeholder": {
            "email": "Filter by email",
            "label": "Filter by label"
        }
    },
    "keys": {
        "status": "Status",
        "email": "Email",
        "label": "Label",
        "created_at": "Created on",
        "updated_at": "Last updated on"
    },
    "modal": {
        "create_merchant_account": {
            "title": "Merchant account creation",
            "steps": {
                "form": "Step {{step}} of {{maxStep}}: Enter email address and label",
                "contract_selection": "Step {{step}} of {{maxStep}}: Contract selection",
                "contract_edition": "Step {{step}} of {{maxStep}}: Editing ranks and merchant label",
                "confirmation": "Step {{step}} of {{maxStep}}: Confirmation"
            },
            "labels": {
                "email": "Email",
                "label": "Label",
                "ranks": {
                    "all": "All ranks",
                    "range": "Range of ranks",
                    "simple": "Entering ranks",
                    "from": "from",
                    "to": "to"
                }
            },
            "placeholders": {
                "email": "Enter an email address here...",
                "label": "100 characters max.",
                "ranks": {
                    "range": "3 digits (ex: 001)",
                    "simple": "(ex: 001, 010, 099)"
                }
            },
            "texts": {
                "contract": "Contract #{{contractNumber}}",
                "bank_code": "Bank code {{bankCode}}",
                "confirmation": "Please confirm merchant account \"{{label}}\" creation associated to 2 following contracts:"
            },
            "success": "Merchant account successfully created !",
            "error": "An error occurred during the creation of the merchant account"
        },
        "add_contracts": {
            "title": "Add contracts to merchant account",
            "steps": {
                "contract_selection": "Step {{step}} of {{maxStep}}: Contract selection",
                "contract_edition": "Step {{step}} of {{maxStep}}: Editing ranks and merchant label",
                "confirmation": "Step {{step}} of {{maxStep}}: Confirmation"
            },
            "labels": {
                "ranks": {
                    "all": "All ranks",
                    "range": "Range of ranks",
                    "simple": "Entering ranks",
                    "from": "from",
                    "to": "to"
                }
            },
            "placeholders": {
                "ranks": {
                    "range": "3 digits (eg: 001)",
                    "simple": "(eg: 001, 010, 099)"
                }
            },
            "texts": {
                "contract": "Contract #{{contractNumber}}",
                "bank_code": "Bank code {{bankCode}}",
                "confirmation": "Confirm that the following contracts will be added to the merchant account \"{{label}}\" :"
            },
            "success": "Contracts successfully added to merchant account !",
            "error": "An error occurred when adding contracts to merchant account"
        },
        "delete_multiple_contracts": {
            "title": "Delete multiple contracts",
            "steps": {
                "contracts_selection": "Step {{step}} of {{maxStep}}: Contract selection",
                "confirm": "Step {{step}} of {{maxStep}}: Confirm multiple deletions"
            },
            "confirmation": {
                "text_1": "This operation will delete {{number}} contract from the Merchant user for \"{{label}}\". Payment information for this contract will not be deleted and will remain accessible. This action will result in the deletion of this contract associated with groups.",
                "text_2": "Please confirm the deletion request for this contract"
            }
        },
        "import": {
            "explanations": {
                "header": "It is possible to add merchant accounts by CSV file. The file to import must contain the following 7 columns :",
                "label_account": "label_account : merchant account label",
                "mail": "mail : email addresses of merchant users who will have access to this account (maximum 5 per account) separated by commas",
                "contrat": "contract : 7-digit contract number",
                "application": "application : identifies the contract application",
                "bank_code": "bank_code : acquirer bank code",
                "rank": "rank : 3-digit rank number. It can contain one or more values separated by commas (example \"001,002,007\"), define a range (example 001-010) or be empty to allow all ranks",
                "contract_label": "contract_label : label to identify each of the contracts listed",
                "multiple_contracts": "It is possible to add multiple contracts for the same merchant account, for this, the contract, application, bank code and rank fields must be filled for each of the contracts to add.",
                "warning": "Warning : only a contract existing on the gateway can be added to a merchant account. If a contract is not known to our gateway, it will not be added."
            },
            "confirmation": "This operation will add {{numberOfAccounts}} merchant accounts. Do you want to continue ?",
            "success": "Merchant accounts created successfully !",
            "error": {
                "invalid_file": "This file is not compatible (.csv only)",
                "error": "Warning ! We have detected the following errors in your CSV file : ",
                "alreadyExistingMerchantAccount": "- Already created",
                "emailIsInvalid": "- Email",
                "contractIsInvalid": "- Contract",
                "bankCodeIsInvalid": "- Bank code",
                "applicationIsInvalid": "- Application",
                "rankIsInvalid": "- Rank",
                "labelAccountIsInvalid": "- Merchant account label",
                "contractLabelIsInvalid": "- Contract label",
                "error_2": "The accounts listed above could not be created. You can correct these errors in a new CSV file and try the operation again or go through the portal.",
                "UNEXPECTED_ERROR": "An error occurred, please try again later.",
                "no_token": "Warning ! No merchant account could be created. Below is the list of errors that have been identified : ",
                "get_example_file": "Do not hesitate to download our model file to help you fill it in.",
                "BAD_FORMAT": "The CSV file is malformed.",
                "TOO_MANY_RESOURCES": "The import of contracts by CSV file is limited to 10,000 contracts",
                "INTERNAL_SERVER_ERROR": "An unknown error occurred"
            },
            "send_reset_password": {
                "text_1": "Congratulations! Your merchant accounts have been successfully created.",
                "text_2": "There is one last step which concerns the sending of personalized passwords for the merchant users of the new accounts that you have just created.",
                "text_3": "Warning ! If you do not click on the button above, you will have to manage the sending of personalized password emails for the merchant users of the new accounts from your portal.",
                "button": "Confirm the sending of personalized passwords",
                "success": "Your request to create merchant accounts has been successfully completed",
                "error": "An error occurred"
            }
        },
        "update_merchant_label": {
            "title": "Modify merchant account label",
            "success": "Merchant account updated successfully!",
            "error": "An error occurred while processing update",
            "label": "Label *",
            "placeholder": "Enter label"
        }
    },
    "status": {
        "ACTIVE": "Activated",
        "INACTIVE": "Deactivated"
    },
    "toast": {
        "success": {
            "activate": "Successful reactivation of the merchant account",
            "deactivate": "Successful deactivation of the merchant account",
            "delete_multiple_contracts": "Contracts successfully deleted !"
        },
        "error": {
            "activate": "Merchant account reactivation aborted",
            "deactivate": "Merchant account deactivation aborted",
            "delete_multiple_contracts": "We have encountered an error with multiple deletions. Please try again."
        }
    }
}